<template>
  <div class="pronoun-menu">
    <div class="dropdown">
      <button
        class="btn btn-info dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside" 
        aria-expanded="false"
      >
        <b>Pronouns</b> <em>({{ selectedPronouns.length }})</em>
      </button>
      <ul
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
      >
        <li
          v-for="(pronoun, key) in pronouns"
          :key="key"
          class="dropdown-item d-flex justify-content-between align-items-center"
          @click="toggle(key)"
          :class="{ 'bg-info fw-bold': selectedPronouns.includes(key) }"
        >
          <span class="me-2 d-inline-block">{{ pronoun }}</span>
          <span
            :class="{
              checked: selectedPronouns.includes(key),
              unchecked: !selectedPronouns.includes(key),
            }"
            class="circle"
          ></span>
        </li>
      </ul>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
export default {
  name: "PronounsMenu",
  computed: {
    ...mapGetters(["pronouns", "selectedPronouns"]), // Map Vuex getters to component computed properties
  },
  data() {
    return {};
  },
  methods: {
    toggle(key) {
      // Dispatch the Vuex action to toggle the tense in the state
      this.$store.dispatch("togglePronoun", key);
    },
  },
};
</script>
  
  <style scoped>
  .pronoun-menu {
    text-align: right;
  }
  
  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  
  .circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid var(----bs-gray-400);
    display: inline-block;
    transition: all 0.3s ease;
  }
  
  /* Empty Circle */
  .unchecked {
    background-color: transparent;
  }
  
  /* Filled Circle */
  .checked {
    background-color: var(--bs-form-valid-color); /* Primary color */
  }
  
  .active {
    font-weight: bold;
  }
</style>
  